import {addSessionsEvent} from 'providers/core/events';

let _initialized = false;
let _referrer;
let _custom;

export const init = () => {
  if (_initialized) {
    throw new Error('Already initialized');
  }
  _initialized = true;
  _referrer = document.referrer || undefined;

  const urlParams = new URLSearchParams(window.location.search);
  _custom = urlParams.get('custom') || undefined;
};

export const addLoginEvent = () => {
  if (!_initialized) {
    throw new Error('Not initialized');
  }
  return addSessionsEvent('LOGIN', _referrer, _custom);
};

export const addRegisterEvent = () => {
  if (!_initialized) {
    throw new Error('Not initialized');
  }
  return addSessionsEvent('REGISTER', _referrer, _custom);
};
